import { authenticatedRequest } from './api.service';
import {
  RiasecQuestionsResponse,
  RiasecLastTestResponse,
  RiasecSubmitRequest,
  RiasecSubmitResponse,
  RiasecProfessionsResponse,
  RiasecType,
  RiasecAIRecommendationResponse, RiasecLastTestResponseFail
} from "../typings/riasec";

export const riasecService = {
  getAllQuestions: async (
    randomize: boolean = true
  ): Promise<RiasecQuestionsResponse> => {
    const response = await authenticatedRequest(
      "GET",
      "/riasec/questions/all",
      { randomize }
    );
    return response as unknown as RiasecQuestionsResponse;
  },

  getLastTest: async (
    withCount: boolean = false
  ): Promise<RiasecLastTestResponse | RiasecLastTestResponseFail> => {
    try {
      const params = withCount ? { wc: 1 } : {};
      const response = await authenticatedRequest(
        "GET",
        "/riasec/last-test",
        params
      );
      return { ...response, status: true } as unknown as RiasecLastTestResponse;
    } catch (e: any) {
      return {
        data: {
          countUser: e?.message?.data?.countUser,
        },
        status: false,
        message: e?.message?.message,
      };
    }
  },

  submitTest: async (
    answers: RiasecSubmitRequest
  ): Promise<RiasecSubmitResponse> => {
    const response = await authenticatedRequest(
      "POST",
      "/riasec/submit-test",
      answers
    );
    return response as unknown as RiasecSubmitResponse;
  },

  getAllProfessions: async (
    type?: RiasecType
  ): Promise<RiasecProfessionsResponse> => {
    const params = type ? { type } : {};
    const response = await authenticatedRequest(
      "GET",
      "/riasec/professions/all",
      params
    );
    return response as unknown as RiasecProfessionsResponse;
  },

  getAIRecommendation: async (
    testId: number
  ): Promise<RiasecAIRecommendationResponse> => {
    const response = await authenticatedRequest(
      "GET",
      `/riasec/ai-recommendation/${testId}`
    );
    return response as unknown as RiasecAIRecommendationResponse;
  },

  getTestById: async (testId: number): Promise<RiasecLastTestResponse> => {
    const response = await authenticatedRequest(
      "GET",
      `/riasec/test/${testId}`
    );
    return response as unknown as RiasecLastTestResponse;
  },

  getPdfStatus: async (testId: number): Promise<any> => {
    const response = await authenticatedRequest(
      "GET",
      `/riasec/pdf-status/${testId}`
    );
    return response as unknown as any;
  },

  downloadPdf: async (testId: number): Promise<Blob> => {
    const response = await authenticatedRequest(
      "POST",
      `/riasec/download-pdf/${testId}`,
      {},
      { responseType: "blob" }
    );
    return response as unknown as Blob;
  },
};